// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionCardView
require("./styles/question-card.css")

const Answer = require("assessments/models/answer").default

export default QuestionCardView = (function () {
  QuestionCardView = class QuestionCardView extends (
    require("lib/static-shim").default(require("lib/core/layout").default)
  ) {
    static initClass() {
      this.prototype.template = require("./templates/question-card.html")
      this.prototype.className = "question-card-view"

      this.prototype.ui = { answerExplanation: ".question-answer-explanation" }

      this.prototype.regions = { response: ".response-region" }

      this.prototype.behaviors = {
        MathJax: {}
      }
    }

    initialize() {
      this._shown = false
      return ({ assessment: this.assessment, isReview: this.isReview } =
        this.options)
    }

    onBeforeRender() {
      return this.$el.addClass(`question-type-${this.model.getTypeKey()}`)
    }

    onRender() {
      const responseView = this._getQuestionResponseView()
      this.listenTo(responseView, "answer:saved", this._onAnswerSaved)
      this.listenTo(responseView, "answer:reset", this._onAnswerReset)
      this.response.show(responseView)
      return this._setStatus()
    }

    onShow() {
      return (this._shown = true)
    }

    serializeData() {
      const data = super.serializeData()
      data.answer = this._getAnswer().toJSON()

      if (data.answer.is_answered && this.assessment.showRealtimeFeedback()) {
        if (data.wrong_answer_tip) {
          data.answer_explanation = data.wrong_answer_tip
        }
      }

      return data
    }

    _onAnswerSaved() {
      this.triggerMethod("question:answered", this.model, this._getAnswer())
      return this.render()
    }

    _onAnswerReset() {
      if (this.ui.answerExplanation != null) {
        this.ui.answerExplanation.hide()
      }
      return this.render()
    }

    _setStatus() {
      const answer = this._getAnswer()
      this.$el.toggleClass("answered", answer.get("is_answered"))
      if (answer.get("is_answered") && this.assessment.showRealtimeFeedback()) {
        return this._showFeedback(answer)
      }
    }

    _showFeedback(answer) {
      const isCorrect = answer.get("is_answered_correctly")
      this.$el
        .toggleClass("correct", isCorrect)
        .toggleClass("incorrect", !isCorrect)

      if (this.ui.answerExplanation.length) {
        // Only animate if this is post render
        if (this._shown) {
          this.ui.answerExplanation.velocity("transition.slideLeftIn")
        } else {
          this.ui.answerExplanation.show()
        }
      }
    }

    _getAnswer() {
      if (this.model.answer == null) {
        this.model.answer = new Answer({ question: this.model.id })
      }
      this.model.answer.question = this.model
      this.model.answer.set("assessment", this.model.get("assessment"))

      // TODO: remove this once legacy code is dropped
      if (this.assessment.get("stepID")) {
        this.model.answer.set("stepID", this.assessment.get("stepID"))
      }

      return this.model.answer
    }

    _getQuestionResponseView() {
      try {
        const ResponseView =
          require(`./question-response-${this.model.getTypeKey()}`).default
        return new ResponseView({
          model: this._getAnswer(),
          question: this.model,
          assessment: this.assessment,
          isReview: this.isReview
        })
      } catch (err) {
        return console.error("Error loading question response type", err)
      }
    }
  }
  QuestionCardView.initClass()
  return QuestionCardView
})()
